import React from 'react';
import { Box, Skeleton } from '@mui/material';

const CategoryCardSkeleton = () => (
  <Box
    className="d-flex align-items-center justify-content-between"
    sx={{
      height: '100%',
      borderRadius: '5px',
      border: '1px solid #CBCBCB',
      p: 1.5,
    }}
  >
    <Box>
      <Skeleton variant="text" width={120} height={32} />
      <Skeleton variant="text" width={80} height={20} />
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Skeleton variant="circular" width={32} height={32} sx={{ mx: 0.5 }} />
      <Skeleton variant="circular" width={32} height={32} sx={{ mx: 0.5 }} />
      <Skeleton variant="rectangular" width={40} height={24} sx={{ borderRadius: 12, mx: 0.5 }} />
    </Box>
  </Box>
);

export default CategoryCardSkeleton;